import React from "react";
import { Button, Badge, Tooltip, Grid } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useGuide } from "../context/GuideContext";

const { useBreakpoint } = Grid;

/**
 * HelpButton - Header button that opens the Help Center
 * Shows a badge with the number of incomplete guides
 */
export const HelpButton: React.FC = () => {
  const { t } = useTranslation("guide");
  const screens = useBreakpoint();
  const { openHelpCenter, getGuideProgress } = useGuide();

  const { completed, total } = getGuideProgress();
  const remaining = total - completed;
  const isMobile = !screens.md;

  return (
    <Tooltip title={t("helpCenter.title")} placement="bottom">
      <Badge
        count={remaining}
        size="small"
        offset={[-2, 2]}
        style={{
          backgroundColor: remaining > 0 ? "#1890ff" : "#52c41a",
        }}
      >
        <Button
          type="text"
          icon={<QuestionCircleOutlined />}
          onClick={openHelpCenter}
          aria-label={t("helpCenter.title")}
          style={{
            fontSize: isMobile ? "16px" : "18px",
            width: isMobile ? 36 : 40,
            height: isMobile ? 36 : 40,
          }}
        />
      </Badge>
    </Tooltip>
  );
};
